import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ResizeEvent } from 'angular-resizable-element';

@Component({
    selector: 'dps-manage-vc',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./dps-manage-vc.scss')],
    host: {'[class.content-container]': 'true'},
    template: require('./dps-manage-vc.html')
})
export default class DPSManageVC {
    private sideNavStyle: Object = {};
    constructor(private translate:TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnInit() {
        console.log('init dataprotection vc manage component');
    }

    onResizeEnd(event: ResizeEvent): void {
        this.sideNavStyle = {
            width: `${event.rectangle.width}px`
        };
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/dps-manage-vc.component.ts